import { useBookingContext } from "../../BookingContext"
import { useGetServicePrice } from "../../common/hooks"
import { SESSION_TYPE } from "../../common/constants"

import { getOnlineOrOffline } from "modules/BookingCommon/common/utils"
import { NETWORK_ERROR_MESSAGE } from "modules/BookingCommon/common/constants"
import { useShowPrice } from "utils/hooks/useShowPrice"
import { Discount, Price } from "components"
import { formatToTotal } from "utils/datetime-format-utils"
import { useOnlyFreeSessions } from "pages/FreePsysPage/useOnlyFreeSessions"

export function SessionInfoShort() {
    const [
        {
            errorMessage,
            selectedTime,
            slotDuration,
            psy,
            selectedDiscount,
            currency,
            isOnline,
            sessionType,
            hasPreviousSessionsWithSamePsychologist,
        },
    ] = useBookingContext()
    const [price, discountPrice] = useGetServicePrice()
    const onlyFree = useOnlyFreeSessions()
    const showPrice = useShowPrice()

    const isOnlineOrOffline = getOnlineOrOffline(isOnline)

    const dateWithoutDot = formatToTotal(selectedTime)

    return (
        <>
            {sessionType === SESSION_TYPE.DEFAULT && (
                <div
                    className="session-date__next-page-button-additional-info"
                    data-testid="session-info-mobile"
                >
                    <span data-testid="session-online-or-offline">{isOnlineOrOffline}</span>,{" "}
                    <span data-testid="session-time">{dateWithoutDot}</span>
                    {!hasPreviousSessionsWithSamePsychologist && <> ({slotDuration} мин)</>}
                    {!onlyFree && showPrice && (
                        <>
                            <>, </>
                            <Price
                                singleServicePrice={discountPrice}
                                psy={psy}
                                currency={currency}
                            />
                            &nbsp;
                            <Discount
                                singleServicePrice={price}
                                psy={psy}
                                className="booking-cards__session-info-price-discount"
                                showDiscountInBooking={
                                    Boolean(selectedDiscount) && price > discountPrice
                                }
                                currency={currency}
                            />
                        </>
                    )}
                </div>
            )}
            {sessionType === SESSION_TYPE.DEPOSIT && (
                <div className="session-date__next-page-button-additional-info">
                    Дата первой сессии: {dateWithoutDot}
                </div>
            )}
            {errorMessage && (
                <div className="booking__error-text">{errorMessage || NETWORK_ERROR_MESSAGE}</div>
            )}
        </>
    )
}
